import React, { Component } from 'react'
import 'react-vant/es/styles'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  unix2date6,
  forbidScroll,
  jumpToRoom,
  inject,
  observer,
} from '../../../helper/devTools.js'
import localstorage from 'src/helper/localstorage'
import { history } from 'src/core/router'
import Message from '../../../component/Message'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { isRtl } from 'src/helper/tool'

dayjs.extend(localizedFormat)

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.partyStore = this.props.store.register('app/partyStore')
  }
  state = {
    lang: {},
    messageTxt: '',
    language: "en",
    mySubList: [],
    myPubList: [],
    showList: [],
    tabStatus: 1,

    showDetail: false,
    isShowDialog: false,

    acTheme: '',
    acDesc: '',
    startDateShow: '',
    hourValue: '',

    currentStatus: -1,
    currentId: -1,

    cannotCreatelang: {
      zh: "您已经创建了活动，今天无法再创建活动",
      en: 'You have already created an event and cannot create another one today!',
      tr: 'Bugün birşey oluşturdunuz ve başka birşey oluşturamazsınız.',
      ar: 'لقد قمت بالفعل بإنشاء حدث ولا يمكن إنشاء حدث آخر اليوم!'
    },
    showCreateGo: false
  }

  async getList() {
    let subList = await this.partyStore.apiGetSubList()
    let pubList = await this.partyStore.apiGetPubList()
    this.setState({
      mySubList: subList && subList.res,
      myPubList: pubList && pubList.res,
      showList: subList && subList.res
    })
    let partycreateCb = localstorage.get('partycreate')
    if (true && partycreateCb && partycreateCb == 1) {
      await this.setState({ tabStatus:2 })
      localstorage.remove('partycreate')
      this.handleListShow(2)
    }
  }

  async initLang() {
    let { language } = this.props.location.query
    language = await getlang(language)
    this.setState({
      lang: setlang(language, this.partyStore.data.lang),
      language: language
    })
    if (language == 'en') {
      setDocumentTitle(this.partyStore.data.lang.en.setDocumentTitle || 'activity');
    } else if (language == 'tr') {
      setDocumentTitle(this.partyStore.data.lang.tr.setDocumentTitle || 'activity');
    } else if (language == 'ar') {
      setDocumentTitle(this.partyStore.data.lang.ar.setDocumentTitle || 'activity');
    } else {
      setDocumentTitle('activity');
    }
    // console.log('%c [ this.partyStore.lang ]-41', 'font-size:20px; background:pink; color:#bf2c9f;', this.partyStore.data.lang)

    console.log('language', language)
    // this.state.lang
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
    this.getList()
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    try {
      // let mySub = await this.partyStore.xxx()
      // let myPub = await this.partyStore.xxx()
    } catch (error) { }

    //try {
    //  this.setState({
    //    uid: uid
    //  })
    //  let getUserInfo = await this.welfareStore.GetUserInfoWeb(uid)
    //  if (getUserInfo && getUserInfo.code == 0) {
    //    this.setState({
    //      userInfo: getUserInfo.res
    //    })
    //  }
    //} catch (error) {
    //  console.error(error)
    //  this.refs.msg.show("error")
    //}
  }

  handleListShow(type) {
    if (type == 1) {
      this.setState({
        showList: this.state.mySubList,
        tabStatus: 1
      })
    }
    if (type == 2) {
      this.setState({
        showList: this.state.myPubList,
        tabStatus: 2
      })
    }
  }

  async handleItemCancel(id, status, gid) {
    if (status == 5 || status == 4) {
      return
    }
    if (this.state.tabStatus == 1) {
      jumpToRoom(gid)
    }
    if (this.state.tabStatus == 2) {
      forbidScroll(true)
      let res = await this.partyStore.apiGetPubDetail(id)
      this.setState({
        acTheme: res && res.res.name,
        acDesc: res && res.res.description,
        // startDateShow: unix2date6(res && res.res.startTime),
        startDateShow: res && res.res.startTime,
        hourValue: res && res.res.duration,
        currentStatus: status,
        currentId: id
      })
      this.setState({
        showDetail: true
      })
    }
  }

  async handleCancelRoom() {
    forbidScroll(false)
    let res = await this.partyStore.apiHandleCancelRoom(this.state.currentId)
    if (res && res.code == 0) {
      this.refs.msg.show(this.state.lang.Suc1)
      this.setState({
        showDetail: false,
        isShowDialog: false
      })
      let pubList = await this.partyStore.apiGetPubList()
      this.setState({
        showList: pubList && pubList.res,
        myPubList: pubList && pubList.res
      })
    }
  }

  sortBy(attr, rev) {
    //第二个参数没有传递 默认升序排列
    if (rev == undefined) {
      rev = 1
    } else {
      rev = rev ? 1 : -1
    }

    return function (a, b) {
      a = a[attr]
      b = b[attr]
      if (a < b) {
        return rev * -1
      }
      if (a > b) {
        return rev * 1
      }
      return 0
    }
  }

  sortList(typeList) {
    // 审核中0
    // 未通过1
    // 未开始2
    // 进行中3
    // 已结束4

    let list = []
    let sortArr = []

    if (this.state.tabStatus == 1) {
      sortArr = [1, 0, 2]
    }

    if (this.state.tabStatus == 2) {
      // sortArr = [3, 2, 0, 4, 5, 1]
      sortArr = [0, 2, 3, 1, 5, 4]
    }

    for (let i = 0; i < sortArr.length; i++) {
      let nList = []
      typeList &&
        typeList.map((item) => {
          if (item.status == sortArr[i]) {
            // list.push(item)
            nList.push(item)
          }
        })
      nList.sort(this.sortBy('startTime', false)).map((itt) => {
        list.push(itt)
      })
    }
    console.log(list)
    return list
  }
  partycreateClick(arr) {
    let temp = 0
    arr.map((e) => {
      if (e.status == 0 || e.status == 2) {
        temp++
      }
    })
    if (temp >= 2) {
      if (this.state.language == 'zh') {
        this.refs.msg.show(this.state.cannotCreatelang.zh)
      } else if (this.state.language == 'tr') {
        this.refs.msg.show(this.state.cannotCreatelang.tr)
      } else if (this.state.language == 'ar') {
        this.refs.msg.show(this.state.cannotCreatelang.ar)
      } else {
        this.refs.msg.show(this.state.cannotCreatelang.en)
      }
    } else {
      let { language, accesstoken, uid } = this.props.location.query
      history.push(`/app/partycreate?language=${this.state.language}`)
    }
  }
  render() {
    return (
      <div className={`party-sub-container`} style={{ direction: `${isRtl(this.state.language) ? 'rtl' : 'ltr'}` }}>
        <Message ref="msg" />

        <div className="party-sub-tab-outer">
          <div className="party-sub-tab">
            <div
              className={`tab-item ${this.state.tabStatus == 1 && 'tab-item-active'}`}
              onClick={() => {
                this.handleListShow(1)
              }}
            >
              {this.state.lang.mySub}
            </div>
            <div
              className={`tab-item ${this.state.tabStatus == 2 && 'tab-item-active'}`}
              onClick={() => {
                this.handleListShow(2)
              }}
            >
              {this.state.lang.myPub}
            </div>
          </div>
        </div>

        <div className="party-sub-room-items">
          {this.sortList(this.state.showList).map((i, k) => {
            return (
              <div
                className="sub-item"
                key={k}
                onClick={() => {
                  this.handleItemCancel(i.id, i.status, i.gid)
                }}
              >
                <div className="pic">
                  <img src={i.image} alt="" />
                </div>
                <div className="info">
                  <div className="title">{i.name}</div>
                  <div className="desc">{i.description}</div>
                  <div className="data">
                    <span className="icon1">
                      <img src="/img/app/partyroom/sub/home1.png" alt="" />
                    </span>
                    <span>{i.dgid || i.gid}</span>
                    &nbsp;&nbsp;
                    <span className="icon2">
                      <img src="/img/app/partyroom/sub/nice1.png" alt="" />
                    </span>
                    <span>{i.subscribeNum}</span>
                  </div>
                </div>
                <div className="status">
                  {/*
                      notStart未开始
                      ongoing进行中
                      done已结束
                      review审核中
                      noPass未通过
                      */}
                  {this.state.tabStatus == 1 && i.status == 0 && this.state.lang.notStart}
                  {this.state.tabStatus == 1 && i.status == 1 && this.state.lang.ongoing}
                  {this.state.tabStatus == 1 && i.status == 2 && this.state.lang.done}

                  {this.state.tabStatus == 2 && i.status == 0 && this.state.lang.review}
                  {this.state.tabStatus == 2 && i.status == 1 && this.state.lang.noPass}
                  {this.state.tabStatus == 2 && i.status == 2 && this.state.lang.notStart}
                  {this.state.tabStatus == 2 && i.status == 3 && this.state.lang.ongoing}
                  {this.state.tabStatus == 2 && i.status == 4 && this.state.lang.done}
                  {this.state.tabStatus == 2 && i.status == 5 && this.state.lang.canceled}

                </div>
              </div>
            )
          })}
        </div>

        {this.state.tabStatus == 1 && this.state.mySubList && this.state.mySubList.length <= 0 && (
          <div className="empty-sub">
            <img src="/img/null.png" alt="" />
            <span>{this.state.lang.noRoom1}</span>
            <div
              className="go"
              onClick={() => {
                history.push(`/app/partyroom?language=${this.state.language}`)
              }}
            >
             {this.state.language == 'tr'?"Göz At":'GO'}          
            </div>
          </div>
        )}

        {this.state.tabStatus == 2 && this.state.myPubList && this.state.myPubList.length <= 0 && (
          <div className="empty-pub">
            <img src="/img/null.png" alt="" />
            <span>{this.state.lang.noRoom2}</span>
            <div
              className="go"
              onClick={() => {
                history.push(`/app/partycreate?language=${this.state.language}`)
              }}
            >
              {this.state.language == 'tr'?"Etkinlik Olustur.":'GO'}     
            </div>
          </div>
        )}

        {this.state.tabStatus == 2 && this.state.myPubList && this.state.myPubList.length > 0 && (
          <div className="empty-pub" style={{ margin: '1rem 0' }}>
            {/* <span>{this.state.lang.noRoom2}</span> */}
            <div
              className="go"
              onClick={
                () => {
                  this.partycreateClick(this.state.myPubList)
                }
              }
            >

              {this.state.lang.creaAC || 'Create Activity'}
            </div>
          </div>
        )
        }

        <div
          className={`party-room-create-container-show`}
          style={{
            left: `${this.state.showDetail ? '0' : '100%'}`
          }}
        >
          <div className="activity-theme">
            <div className="title">{this.state.lang.theme}</div>
            <div className="content">
              <span>{this.state.acTheme}</span>
            </div>
          </div>
          <br />

          <div className="activity-desc">
            <div className="title">{this.state.lang.desc}</div>
            <div className="content">
              <span>{this.state.acDesc}</span>
              <div className="limit">{this.state.acDesc && this.state.acDesc.length}/100</div>
            </div>
          </div>
          <br />

          <div className="activity-time">
            <div className="title">{this.state.lang.time}</div>
            <div className="content">
              <div className="item">
                <span>
                  {this.state.lang.st}：
                  { this.state.startDateShow ? dayjs(this.state.startDateShow * 1000).format('lll') : ''}
                </span>
                <span className="jt">
                  <img src="/img/app/partyroom/create/right.png" alt="" />
                </span>
              </div>
              <div className="line"></div>
              <div className="item">
                <span>
                  {this.state.lang.duration}：{this.state.hourValue}
                  {this.state.hourValue && this.state.lang.h}
                </span>
                <span className="jt">
                  <img src="/img/app/partyroom/create/right.png" alt="" />
                </span>
              </div>
            </div>
          </div>

          <div className="zw"></div>

          <div className="handle">
            <div
              className="btn"
              onClick={() => {
                forbidScroll(false)
                this.setState({ showDetail: false })
              }}
            >
              {this.state.lang.back}
            </div>
            <div
              className="cancel"
              style={{
                backgroundImage: `url(${this.state.currentStatus == 3
                  ? '/img/app/partyroom/create/btn2.png'
                  : '/img/app/partyroom/create/btn.png'
                  })`
              }}
              onClick={() => {
                if (this.state.currentStatus == 3) {
                  return
                }
                forbidScroll(false)
                this.setState({ isShowDialog: true })
              }}
            >
              {this.state.lang.no}
            </div>
          </div>
        </div>

        <div className="dialog" style={{ display: `${this.state.isShowDialog ? 'block' : 'none'}` }}>
          <div className="mask"></div>
          <div className="content-wrapper">
            <div className="content">
              {/* 返回金币 */}
              {this.state.currentStatus == 0 && this.state.lang.desc1}
              {/* 不返回金币 */}
              {this.state.currentStatus == 2 && this.state.lang.desc2}
            </div>
            <div className="handle">
              <div
                className="no"
                onClick={() => {
                  this.setState({ isShowDialog: false })
                }}
              >
                {this.state.lang.back}
              </div>
              <div className="line"></div>
              <div
                className="yes"
                onClick={() => {
                  this.handleCancelRoom()
                }}
              >
                {this.state.lang.yes}
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/partysub/index.js